import {PropertyFilterProps} from '@amzn/awsui-components-react'

const I18N_STRINGS: PropertyFilterProps.I18nStrings = {
    clearAriaLabel: 'clear',
    clearFiltersText: 'clear',
    operationAndText: 'and',
    operationOrText: 'or',
    operatorContainsText: 'contains',
    cancelActionText: 'Cancel',
    applyActionText: 'Apply',
    editTokenHeader: 'Edit query',
    propertyText: 'Property',
    operatorText: 'Operator',
}

export const METADATA_I18N_STRINGS: PropertyFilterProps.I18nStrings = {
    filteringAriaLabel: 'Find entities by allowed values',
    filteringPlaceholder: 'Find entities by allowed values',
    ...I18N_STRINGS,
}

export const SEARCH_BY_INPUT_I18N_STRINGS: PropertyFilterProps.I18nStrings = {
    filteringAriaLabel: 'Search executions by input field(s)',
    filteringPlaceholder: 'Search executions by input field(s)',
    ...I18N_STRINGS,
}

export const SEARCH_BY_OUTPUT_I18N_STRINGS: PropertyFilterProps.I18nStrings = {
    filteringAriaLabel: 'Search executions by output field(s)',
    filteringPlaceholder: 'Search executions by output field(s)',
    ...I18N_STRINGS,
}
